import { DarkGreenButton } from "features/DarkGreenButton";
import { useState } from "react";
import AddNewEventMenu from "./AddNewEventMenu";
import { useAddNewEventDialogs } from "./useAddNewEventDialogs";

interface AddNewEventButtonProps {
  maxWidth?: string;
}

export default function AddNewEventButton({
  maxWidth = "150px",
}: AddNewEventButtonProps) {
  const [eventMenuAnchor, setEventMenuAnchor] = useState<null | HTMLElement>(
    null
  );
  const eventMenuOpen = Boolean(eventMenuAnchor);
  const { handleEventTypeClick, dialogs } = useAddNewEventDialogs();

  const handleEventMenuOpen = (event: React.MouseEvent<HTMLElement> | void) => {
    if (event) {
      setEventMenuAnchor(event.currentTarget ?? null);
    }
  };

  const handleEventMenuClose = () => {
    setEventMenuAnchor(null);
  };

  const handleEventMenuItemClick = (eventType: string) => {
    handleEventMenuClose();
    handleEventTypeClick(eventType);
  };

  return (
    <>
      <DarkGreenButton
        title="Add new event"
        handleUploadClick={handleEventMenuOpen}
        maxWidth={maxWidth}
      />

      <AddNewEventMenu
        anchorEl={eventMenuAnchor}
        open={eventMenuOpen}
        onClose={handleEventMenuClose}
        onEventTypeClick={handleEventMenuItemClick}
      />

      {dialogs}
    </>
  );
}
